import { render, staticRenderFns } from "./CustomerDraftPriceStatus.vue?vue&type=template&id=5adbe45f&"
import script from "./CustomerDraftPriceStatus.vue?vue&type=script&lang=js&"
export * from "./CustomerDraftPriceStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports